import { render, staticRenderFns } from "./AddonsTypeTable.vue?vue&type=template&id=04a89b14&"
import script from "./AddonsTypeTable.vue?vue&type=script&lang=js&"
export * from "./AddonsTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports